import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { ListBox } from "primereact/listbox";
import { Toast } from "primereact/toast";

import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";

import api from "../../../services/api";

import { RevisaoGraficoSetorMes } from "../../../components/Revisao/GraficoSetorMes";
import RevisaoGraficoSetorTotalMes from "../../../components/Revisao/GraficoSetorTotalMes";
import RevisaoGraficoSetorTipoDefeito from "../../../components/Revisao/GraficoSetorTipoDefeito";
import GraficoClassificacaoPorcentagem from "../../../components/Revisao/GraficoClassificacaoPorcentagem";
import RevisaoGraficoSetorPorcentagem from "../../../components/Revisao/GraficoSetorPorcentagem";
import { RevisaoGraficoResiduos } from "../../../components/Revisao/GraficoResiduos";
import TabelaArtigos from "../../../components/Revisao/TabelaArtigos";
import { RevisaoGraficoArtigo } from "../../../components/Revisao/GraficoArtigo";
import { TabelaArtigoDefeito } from "../../../components/Revisao/TabelaArtigoDefeito";
import { GraficoProducaoResiduo } from "../../../components/Revisao/GraficoProducaoResiduo";
import { GraficoRelacaoProdRes } from "../../../components/Revisao/GraficoRelacaoProdRes";
import { RevisaoDefeitoTear } from "../../../components/Revisao/GraficoTecelagemTear";
import { RevisaoDefeitoEngomagem } from "../../../components/Revisao/TabelaEngomagemClassificacao";
import { GraficoTecelagemSetup } from "../../../components/Revisao/GraficoTecelagemSetup";
import GraficoEvolucaoResiduo from "../../../components/Revisao/GraficoEvolucaoResiduo";

const BUTTONS = [
  { label: "Total Revisado", value: "3" },
  { label: "Setores", value: "0" },
  { label: "Produção", value: "4" },
  { label: "Classificação", value: "1" },
  { label: "Resíduos e Retalhos", value: "2" },
];

const actualYear = new Date().getFullYear();

const YEARS = [actualYear, actualYear - 1, actualYear - 2];
const TIPOS_RELATORIO = [
  { label: "Produção", value: 1 },
  { label: "Mensal", value: 2 },
];

const MONTHS = [
  "JAN",
  "FEV",
  "MAR",
  "ABR",
  "MAI",
  "JUN",
  "JUL",
  "AGO",
  "SET",
  "OUT",
  "NOV",
  "DEZ",
];

const initialState = {
  artigos: [],
  defeitos: [],
  defeitos_artigo: [],
  porcentagem_total: [],
  producao_por_artigo: [],
  residuos: [],
  residuos_produto: [],
  total_revisado: [],
  setores: [],
  setores_residuos: [],
  producao_geral: [],
};

export default function Revisao() {
  const [data, setData] = useState({ ...initialState });
  const [defeitos, setDefeitos] = useState([]);
  const [defeito, setDefeito] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [month, setMonth] = useState(new Date().getMonth());
  const [reportType, setReportType] = useState(1);
  const [setor, setSetor] = useState(null);
  const [setorRes, setSetorRes] = useState(null);
  const [type, setType] = useState("0");
  const [year, setYear] = useState(new Date().getFullYear());

  const [initialDate, setInitialDate] = useState(new Date());
  const [finalDate, setFinalDate] = useState(new Date());

  const [isLoading, setIsLoading] = useState(false);
  const [showTable, setShowTable] = useState(false);

  const [selectedResiduo, setSelectedResiduo] = useState(null);

  const toast = useRef();

  const showError = (error) =>
    toast.current.show({
      summary: "Ocorreu um Erro",
      severity: "error",
      detail: error.response ? error.response.data.message : error.message,
    });

  const fetchData = useCallback(() => {
    setIsLoading(true);
    api
      .get("revisao-dashboard/" + year + "/" + reportType)
      .then((response) => {
        setData(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }, [reportType, year]);

  const handleSearch = () => {
    if (!initialDate || !finalDate) {
      return;
    }

    let dataInicial =
      initialDate.getFullYear() +
      "-" +
      String(initialDate.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(initialDate.getDate());
    let dataFinal =
      finalDate.getFullYear() +
      "-" +
      String(finalDate.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(finalDate.getDate());

    setIsLoading(true);
    api
      .get(`revisao-dashboard/${year}/2`, {
        params: {
          data_inicial: dataInicial,
          data_final: dataFinal,
          filtrar_por_data: true,
        },
      })
      .then((response) => {
        setData(response.data);
        if(response.data.total_revisado && response.data.total_revisado.length === 1) {
          setMonth(parseInt(response.data.total_revisado[0].mes));
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        showError(error);
      });
  };

  const calcularDesperdicioRelativo = () => {
    const totalMetros = data.producao_por_artigo.reduce(
        (acc, curr) => acc + parseFloat(curr.metrostotal || 0),
        0
    );

    const totalResiduoKg = data.residuos
        .filter(r => r.setor === "Tecelagem")
        .reduce(
            (acc, curr) => acc + parseFloat(curr.soma || 0),
            0
        );

    if (totalMetros === 0) return "0.00";

    return ((totalResiduoKg / totalMetros) * 1000).toFixed(2);
  };

  useEffect(() => {
    if (setor !== null) {
      let filteredData = data.defeitos.filter((element) => {
        return (
          element.cod_defeitotipo === setor && month === parseInt(element.mes)
        );
      });

      let defeitos = [];

      filteredData.forEach((item) => {
        let index = defeitos.findIndex((element) => {
          return element.descricao === item.descricao;
        });

        if (index === -1) {
          defeitos.push({
            id: item.cod_defeito,
            descricao: item.descricao,
          });
        }
      });

      defeitos = defeitos.sort((a, b) => {
        if (a.descricao < b.descricao) return -1;
        if (a.descricao > b.descricao) return 1;
        return 0;
      });

      setDefeitos(defeitos);
      setFilteredData(filteredData);
    }
  }, [data, month, setor, type]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (isLoading) return <Loading />;

  return (
    <div>
      <Menu />
      <Toast ref={toast} />
      <Card className="p-m-1" title="Controle de Qualidade Revisão">
        <div className="p-d-flex p-flex-row p-jc-between">
          <div>
            <Calendar
              className="p-m-1"
              dateFormat="dd/mm/yy"
              onChange={(e) => setInitialDate(e.value)}
              mask="99/99/9999"
              placeholder="Data Inicial"
              value={initialDate}
            />

            <Calendar
              className="p-m-1"
              dateFormat="dd/mm/yy"
              onChange={(e) => setFinalDate(e.value)}
              mask="99/99/9999"
              placeholder="Data Final"
              value={finalDate}
            />

            <Button
              className="p-m-1"
              icon="pi pi-search"
              onClick={() => handleSearch()}
            />
          </div>
          <div>
            <label>Mostrar Tabela Artigo X Defeito</label>
            <Dropdown
              className="p-m-1"
              onChange={(e) => setShowTable(e.value)}
              options={[
                { label: "Não", value: false },
                { label: "Sim", value: true },
              ]}
              value={showTable}
            />

            <Dropdown
              className="p-m-1"
              onChange={(e) => setReportType(e.value)}
              options={TIPOS_RELATORIO}
              value={reportType}
            />
            <Dropdown
              className="p-m-1"
              onChange={(e) => setYear(e.value)}
              options={YEARS}
              value={year}
            />
          </div>
        </div>

        <div className="p-d-flex p-flex-row p-jc-between">
          {BUTTONS.map((item, index) => (
            <Button
              className={
                "p-button-secondary p-col p-m-2 " +
                (type === item.value ? "p-button-success" : "")
              }
              key={`button${index}`}
              label={item.label}
              onClick={() => setType(item.value)}
            />
          ))}
        </div>

        {type === "3" && (
          <div>
            <RevisaoGraficoSetorTotalMes
              data={data.total_revisado}
              months={MONTHS}
              title="Total Revisado por Mês (m)"
            />

            <TabelaArtigos data={data.producao_por_artigo} months={MONTHS} />
          </div>
        )}

        {["0", "1"].includes(type) && (
          <div>
            <div className="p-d-flex p-flex-row p-jc-between p-mt-2 p-mb-4">
              {data.setores.map((item, index) => (
                <Button
                  className={
                    "p-button-secondary p-col p-m-2 " +
                    (item.idtecdefeitotipo === setor ? "p-button-success" : "")
                  }
                  key={`setor${index}`}
                  label={item.nome}
                  onClick={() => {
                    if(setor === item.idtecdefeitotipo) {
                      setSetor(null);
                    } else {
                      setSetor(item.idtecdefeitotipo);
                    }
                  }}
                />
              ))}
            </div>
            {type === "0" && (
              <>
                <div className="p-grid">
                  {setor !== null && (
                    <RevisaoGraficoSetorTotalMes
                      data={data.defeitos}
                      months={MONTHS}
                      setor={setor}
                    />
                  )}
                  {setor !== null && (
                    <RevisaoGraficoSetorPorcentagem
                      data={data.porcentagem_total}
                      months={MONTHS}
                      setor={setor}
                      setores={data.setores}
                    />
                  )}
                </div>

                <div className="p-grid">
                  {setor !== null && (
                    <>
                      <div className="p-grid p-col-12">
                        {MONTHS.map((item, index) => (
                          <Button
                            className={
                              "p-m-1 p-button-secondary " +
                              (month === index + 1 ? "p-button-success" : "")
                            }
                            key={`month${index + 1}`}
                            label={item}
                            onClick={() => {
                              setMonth(index + 1);
                            }}
                          />
                        ))}
                      </div>

                      {setor === 3 && (
                        <>
                          <RevisaoGraficoSetorTipoDefeito
                            data={data.defeitos}
                            defeito={[-1, 11]}
                            months={MONTHS}
                            setor={setor}
                            tipo={2}
                          />
                          <RevisaoGraficoSetorTipoDefeito
                            data={data.defeitos}
                            defeito={[-2, 32]}
                            months={MONTHS}
                            setor={setor}
                            tipo={2}
                          />
                        </>
                      )}

                      <RevisaoGraficoSetorMes
                        data={filteredData}
                        setor={setor}
                      />

                      <RevisaoGraficoSetorTipoDefeito
                        data={data.defeitos}
                        defeito={[defeito]}
                        months={MONTHS}
                        setor={setor}
                      />

                      <div className="p-col-2">
                        <ListBox
                          listStyle={{ height: "350px" }}
                          onChange={(e) => {
                            setDefeito(e.value);
                          }}
                          options={defeitos}
                          optionLabel="descricao"
                          optionValue="id"
                          value={defeito}
                        />
                      </div>

                      <RevisaoGraficoArtigo
                        data={data.defeitos_artigo}
                        defeitosengomagem3e4={data.defeitos_engomagem3e4}
                        month={month}
                        setor={setor}
                        title="Total por Artigo"
                        type="1"
                      />

                      <RevisaoGraficoArtigo
                        data={data.defeitos_artigo}
                        defeitosengomagem3e4={data.defeitos_engomagem3e4}
                        month={month}
                        dataProd={data.producao_por_artigo}
                        setor={setor}
                        title="Percentual de Defeitos por Artigo / Revisado"
                        type="2"
                      />

                      {setor === 1 && (
                        <RevisaoDefeitoTear
                          defeitos={data.defeitos}
                          month={month}
                          dataProd={data.producao_geral}
                          setor={setor}
                        />
                      )}

                      <RevisaoDefeitoEngomagem
                        defeitos={data.defeitos}
                        month={month}
                        setor={setor}
                      />

                      {showTable && (
                        <>
                          <TabelaArtigoDefeito
                            data={data.defeitos_artigo}
                            defeitosengomagem3e4={data.defeitos_engomagem3e4}
                            dataProd={data.producao_por_artigo}
                            month={month}
                            setor={setor}
                          />

                          <TabelaArtigoDefeito
                            data={data.defeitos_artigo}
                            defeitosengomagem3e4={data.defeitos_engomagem3e4}
                            dataProd={data.producao_por_artigo}
                            month={month}
                            setor={setor}
                            type="media"
                          />
                        </>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        )}

        {type === "1" && (
          <div>
            <RevisaoGraficoSetorPorcentagem
              chartType="revisado"
              data={data.porcentagem_total}
              months={MONTHS}
              setor={setor ? setor : -1}
              setores={data.setores}
            />

            <GraficoClassificacaoPorcentagem
              data={data.porcentagem_total}
              months={MONTHS}
              setores={data.setores}
              tipo="porcentagem"
            />

            <GraficoClassificacaoPorcentagem
              data={data.porcentagem_total}
              months={MONTHS}
              setores={data.setores}
              tipo="total"
            />
          </div>
        )}

        {["2", "4"].includes(type) && (
          <div>
            <div className="p-d-flex p-flex-row p-jc-between">
              {data.setores_residuos.map((setorLabel) => (
                <Button
                  className={
                    "p-button-secondary p-col p-m-2 " +
                    (setorRes === setorLabel ? "p-button-success" : "")
                  }
                  key={setorLabel}
                  label={setorLabel}
                  onClick={() => setSetorRes(setorLabel)}
                />
              ))}
            </div>

            {setorRes !== null && type === "2" && (
              <>
                <div className="p-grid p-col-12">
                  {MONTHS.map((item, index) => (
                    <Button
                      className={
                        "p-m-1 p-button-secondary " +
                        (month === index + 1 ? "p-button-success" : "")
                      }
                      key={`month${index + 1}`}
                      label={item}
                      onClick={() => {
                        setMonth(index + 1);
                      }}
                    />
                  ))}
                </div>

                <GraficoRelacaoProdRes
                  graficoComMeta={true}
                  months={MONTHS}
                  producao_geral={data.producao_geral}
                  residuos={data.residuos}
                  setores={data.setores}
                  setor={setorRes}
                />

                <GraficoProducaoResiduo
                  months={MONTHS}
                  producao_geral={data.producao_geral}
                  setor={setorRes}
                />

                <GraficoTecelagemSetup
                  data={data}
                  month={month}
                  months={MONTHS}
                  setor={setorRes}
                />

                <RevisaoGraficoResiduos
                  month={month}
                  months={MONTHS}
                  residuos={data.residuos}
                  residuosProduto={data.residuos_produto}
                  setor={setorRes}
                />

                <div className="p-m-2">
                <Card className="p-mb-3" style={{ width: "400px", borderRadius: "10px", }}>
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: "15px", fontWeight: "600", color: "#7f8c8d", marginBottom: "8px"}}>
                      Desperdício Relativo
                    </div>
                    <div style={{ fontSize: "14px", color: "#95a5a6", marginBottom: "12px"}}>
                      Ano {year}
                    </div>
                    <h2 style={{ margin: 0, color: "#e74c3c", fontSize: "28px", fontWeight: "700"}}>
                      {calcularDesperdicioRelativo()}{" "}
                      <span style={{ fontSize: "18px" }}>g/m</span>
                    </h2>
                  </div>
                </Card>

                  <Dropdown 
                    options={[...new Set(data.residuos_produto
                      .filter(r => r.setor === setorRes)
                      .map(r => r.descricao))
                    ].map(desc => ({ label: desc, value: desc }))}
                    value={selectedResiduo}
                    onChange={(e) => setSelectedResiduo(e.value)}
                    placeholder="Filtre por Tipo de Resíduo"
                    showClear
                  />
                  
                  <GraficoEvolucaoResiduo 
                    months={MONTHS}
                    residuosProduto={data.residuos_produto}
                    setor={setorRes}
                    selectedResiduo={selectedResiduo}
                  />
                </div>
              </>
            )}

            {setorRes !== null && type === "4" && (
              <>
                <GraficoProducaoResiduo
                  graficoComMeta={true}
                  months={MONTHS}
                  producao_geral={data.producao_geral}
                  setor={setorRes}
                  setores={data.setores}
                />
              </>
            )}
          </div>
        )}
      </Card>
    </div>
  );
}
